/* eslint-disable @angular-eslint/no-output-on-prefix */
/* eslint-disable max-classes-per-file */
import { CommonModule } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  NgModule,
  OnDestroy,
  Output,
} from '@angular/core';
import { HeaderModule } from '../header/header.component';
import { SynlabHeaderService } from './synlab-header.service';
import { takeUntil } from 'rxjs/operators';
import { NavigationEnd, Router } from '@angular/router';
import { Observable, of, ReplaySubject } from 'rxjs';
import { Profile } from '../core';
import { OrganizationInterface } from '../../interfaces/organization.interface';
import { OrganizationService } from '../core/organization/organization.service';

const HIDDEN_LINK_ROUTES = [
  '/registration/complete_registration_ptee',
  '/registration/secure_account',
  '/registration/complete-registration',
  '/registration/complete_tara',
];

@Component({
    selector: 'syn-synlab-header',
    templateUrl: './synlab-header.component.html',
    styleUrls: ['./synlab-header.component.css'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    providers: [SynlabHeaderService],
    standalone: false
})
export class SynlabHeaderComponent implements OnDestroy {
  links$ = of([]);
  user$: Observable<Profile> = of(null);
  organizations: OrganizationInterface[] = [];

  myAccountLink$ = this.headerService.myAccountLink$;
  brandLogoLink$ = this.headerService.brandLogoLink$;

  destory$ = new ReplaySubject(1);

  @Output() onLogout = new EventEmitter();
  @Input() disableLinks: boolean = false;

  constructor(
    private headerService: SynlabHeaderService,
    private route: Router,
    private organizationService: OrganizationService,
  ) {
    this.route.events.pipe(takeUntil(this.destory$)).subscribe(e => {
      if (e instanceof NavigationEnd && !e.url.includes('renewtoken')) {
        if (HIDDEN_LINK_ROUTES.some(u => e.url.includes(u))) {
          this.links$ = of([]);
          this.user$ = of(null);
        } else {
          this.links$ = this.headerService.links$;
          this.user$ = this.headerService.user$;
          this.fetchOrganizations();
        }
      }
    });
  }

  private fetchOrganizations() {
    this.user$.pipe(takeUntil(this.destory$)).subscribe(async user => {
      if (user?.synlabId && user.claims && user.claims.length > 0) {
        const userIdClaim = user.claims.find(claim => claim.claimType === 'userId');
        if (userIdClaim && userIdClaim.claimValue) {
          const response = await this.organizationService.getUserOrgs(
            userIdClaim.claimValue,
            user.synlabId,
          );
          this.organizations = response;
        }
      }
    });
  }

  logout() {
    this.onLogout.emit();
  }

  ngOnDestroy(): void {
    this.destory$.next(true);
    this.destory$.complete();
  }
}
@NgModule({
  imports: [CommonModule, HeaderModule],
  declarations: [SynlabHeaderComponent],
  exports: [SynlabHeaderComponent],
})
export class SynlabHeaderModule {}
